module.exports = __webpack_public_path__ + "static/media/icaro.209316a9.jfif";